var exports = {
  "Lw": "x52a3aa3b--687972--overlay",
  "ql": "x52a3aa3b--687972--overlayFadeIn",
  "rf": "x52a3aa3b--687972--body",
  "Qs": "x52a3aa3b--687972--content",
  "Vd": "x52a3aa3b--687972--slideUp",
  "d5": "x52a3aa3b--687972--head",
  "VN": "x52a3aa3b--687972--close",
};

module.exports = exports;
